import { render } from "./OrderCard.vue?vue&type=template&id=59ed0cf8"
import script from "./OrderCard.vue?vue&type=script&lang=js"
export * from "./OrderCard.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./OrderCard.vue?vue&type=style&index=0&id=59ed0cf8&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__